const ConstantsTexts = {
  CODE_1:  "מודל לתיעדוף מתקני תשתית לתפעול תח״צ באוטובוסים",
  CODE_2: "חיפוש מתקן",
  CODE_3: "הגדרות מודל",
  CODE_4: "יעילות תחבורתית",
  CODE_5: "יעילות כלכלית",
  CODE_6: "שמירה וחישוב מחדש",
  CODE_7: "ביטול",
  CODE_8: "ישימות",
  CODE_9: "עמדת הרשות המקומית",
  CODE_10: "טבעת מטרופולינית",
  CODE_11: "עלויות ₪",
  CODE_12: "עלות מסוף קטן",
  CODE_13: "עלות מסוף בינוני",
  CODE_14: "עלות מסוף גדול",
  CODE_15: "עלות מתקן משולב",
  CODE_16: "עלות חניון לילה",
  CODE_17: "דחיפות",
  CODE_18: "שנת יעד",
  CODE_19: "חשיבות לשירות",
  CODE_20: "כמות מסופים במרחב",
  CODE_21: "פוטנציאל",
  CODE_22: "כמות אוכלוסייה",
  CODE_23: "צמצום פער תפעולי",
  CODE_24: "יחס",
  CODE_25: "עלות לנוסע",
  CODE_26: "עלות לנסיעה",
  CODE_27: "נתוני מסוף",
  CODE_28: "עדכונים",
  CODE_29: "ניקוד כולל",
  CODE_30: "גודל מסוף נדרש",
  CODE_31: "נדרש",
  CODE_32: "דונם",
  CODE_33: "שים/י לב",
  CODE_34: "שמירה",
  CODE_35: "שנת צורך תחבורתי",
  CODE_36: "עמדת הרשות המקומית ומורכבות התיאומים",
  CODE_37: "הערות",
  CODE_39: "חשיבות",
  CODE_40: 'מתקנים נוספים במרחק 2 ק"מ',
  CODE_41: "צפיפות אוכלוסייה / מועסקים 2040",
  CODE_42: "הפרש בין שטח מתוכנן",
  CODE_43: "לשטח קיים",
  CODE_44: "יחס בין גודל המתקן לבין",
  CODE_45: "פער השטח הנדרש",
  CODE_46: "שטח קיים",
  CODE_47: "למרחב תכנון",
  CODE_48: "שטח נדרש",
  CODE_49: "עלות מוערכת למסוף",
  CODE_50: "עלות מוערכת להסדרי תנועה",
  CODE_51: 'עלות כוללת במלש"ח',
  CODE_52: "פוטנציאל נסיעות לשעה",
  CODE_53: "פוטנציאל נסיעות ליום",
  CODE_54: "מס' עמדות טעינה",
  CODE_55: "מס' עמדות כולל",
  CODE_56: "עלות מבנים",
  CODE_57: "נוסעים",
  CODE_58: "טבעת המסוף",
  CODE_59: "בחרת לצאת ממצב עריכה/יצירת גרסת מסוף ללא שמירת השינויים",
  CODE_60: "יציאה ללא שמירה",
  CODE_61: "חזרה למצב עריכה",
  CODE_62: "המודל נשמר וחושב מחדש",
  CODE_63: "מחוז",
  CODE_64: "רשות",
  CODE_65: "מתקן",
  CODE_66: "מ -",
  CODE_67: "עד -",
  CODE_68: "סוג מסוף",
  CODE_69: "סטטוס",
  CODE_71: "שטח קיים למרחב תכנון",
  CODE_72: "שטח נדרש למרחב תכנון",
  CODE_73: "טעינת רשימת המסופים נכשלה",
  CODE_74: "קבלת המידע על המודל נכשלה",
  CODE_75: "קבלת המידע על המסוף נכשלה",
  CODE_76: "עדכון המסוף נכשל",
  CODE_77: "עדכון המודל נכשל",
  CODE_78: 'סה"כ האחוזים של שבעת מדדי המודל אינם מסתכמים ל-100%.',
  CODE_79: "המודל אינו נשמר, יש לתקנו ולשמור אותו מחדש.",
  CODE_80: "במדד ״חשיבות לשירות״ בוצעה טעות:",
  CODE_81: '1. בכל ציון הערך של "עד-" חייב להיות גדול מהערך של "מ-".​',
  CODE_82: '2. הערך של "מ-" של ציון 5 חייב להיות 0.​',
  CODE_83: '3. הערך של "עד-" של ציון מסוים חייב להיות שווה ל-"מ-" של הציון הקודם לו.​',
  CODE_84: "אין הרשאה להיכנס",
  CODE_85: "במדד ״פוטנציאל״ בוצעה טעות:",
  CODE_86: '1. בכל ציון הערך של "עד-" חייב להיות גדול מהערך של "מ-".​',
  CODE_87: '2. הערך של "מ-" של ציון 1 חייב להיות 0.​',
  CODE_88: '3. הערך של "עד-" של ציון מסוים חייב להיות שווה ל-"מ-" של הציון שלאחריו.​',
  CODE_90: "במדד ״צמצום פער תפעולי״ בוצעה טעות:",
  CODE_91: '1. בכל ציון הערך של "עד-" חייב להיות גדול מהערך של "מ-".​​',
  CODE_92: '2. הערך של "מ-" של ציון 1 חייב להיות 0.​',
  CODE_93: '3. הערך של "עד-" של ציון מסוים חייב להיות שווה ל-"מ-" של הציון שלאחריו.​',
  CODE_95: "במדד ״עלות לנוסע״ בוצעה טעות:",
  CODE_96: '1. בכל ציון הערך של "עד-" חייב להיות גדול מהערך של "מ-".​',
  CODE_97: '2. הערך של "מ-" של ציון 5 חייב להיות 0.​',
  CODE_98: '3. הערך של "עד-" של ציון מסוים חייב להיות שווה ל-"מ-" של הציון הקודם לו.​',
  CODE_100: "במדד ״עלות לנסיעה״ בוצעה טעות:",
  CODE_101: '1. בכל ציון הערך של "עד-" חייב להיות גדול מהערך של "מ-".​',
  CODE_102: '2. הערך של "מ-" של ציון 5 חייב להיות 0.​',
  CODE_103: '3. הערך של "עד-" של ציון מסוים חייב להיות שווה ל-"מ-" של הציון הקודם לו.​',
  CODE_105: "ראשונה",
  CODE_106: "שניה",
  CODE_107: "שלישית",
  CODE_108: "רביעית",
  CODE_110: "יש לבחור מסוף",
  CODE_111: "חודשי עבודה",
  CODE_112: "עלות הסדרי תנועה לחודש",
  CODE_113: "עלות כללית להסדרי תנועה",
  CODE_114: "זמן חיים",
  CODE_115: "ימי עבודה",
  CODE_116: "עלות לדונם",
  CODE_117: "עריכה",
  CODE_118: "גירסה",
  CODE_119: "מודל",
  CODE_120: "גירסה חדשה",
  CODE_121: "שמירה כמודל חדש",
  CODE_122: "מרחב תכנון",
  CODE_123: "גורם מקדם",
  CODE_124: "סטטוס תקצוב",
  CODE_125: "בעלות",
  CODE_126: "קווים",
  CODE_127: "קווים במסוף זה",
  CODE_128: "קווים חולפים",
  CODE_131: "שגיאה לא ידועה",
  CODE_132: "טעינת הנתונים נכשלה",
  CODE_136: "צמצום פער",
  CODE_137: "עמדת רשות",
  CODE_141: 'מק"ט ארז',
  CODE_144: "סוג",
  CODE_146: "סטט. תקציבי",
  CODE_148: "תחבורתי",
  CODE_149: "יישומי",
  CODE_150: "כלכלי",
  CODE_151: "ציון",
  CODE_152: "דירוג",
  CODE_153: "טעינת מסך הדאשבורד נכשלה",
  CODE_154: "הורדת קובץ ה-Excel נכשלה",
  CODE_155: "מודל לתיעדוף מתקני תשתית",
  CODE_156: "ניקוד מסוף מקור",
  CODE_157: "יצירת גירסה",
  CODE_160: "גרסת מודל {version} נוצרה בהצלחה",
  CODE_161: "בחרת לצאת ממצב עריכה/יצירת גרסת מודל ללא שמירת השינויים",
  CODE_162: "זהו שדה חובה",
  CODE_163: "שים לב: הנתון שטח נדרש למרחב תכנון חייב להיות גדול מהנתון שטח קיים למרחב תכנון.",
  CODE_164: "דאשדבורד מסופים",
  CODE_165: "פריטים נבחרו",
  CODE_166: "שינוי מודל בסיס",
  CODE_167: "שינוי מסוף בסיס",
  CODE_168: "המודל נקבע כ-0 בהצלחה",
  CODE_169: "המסוף נקבע כ-0 בהצלחה",
  CODE_170: "לא ניתן לבחור גרסה 0. יש לבחור גרסה אחרת.",
  CODE_171: "האם את/ה בטוח/ה שברצונך להחיל את גרסת מודל {version} על גרסת מודל 0",
  CODE_172: "האם את/ה בטוח/ה שברצונך להחיל את גרסת מסוף {version} על גרסת מסוף 0",
  CODE_173: "קביעת מודל בסיס",
  CODE_174: "קביעת מסוף בסיס",
  CODE_175: "קביעת בסיס המודל כ-0 נכשלה",
  CODE_176: "קביעת בסיס המסוף כ-0 נכשלה",
  CODE_177: "מחיקת מסוף",
  CODE_178: "שמירת שינויים",
  CODE_179: "רשות מקומית",
  CODE_180: "מק״ט מסוף",
  CODE_181: "יצירת מסוף",
  CODE_182: "שמירת מסוף",
  CODE_183: "מק״ט ארז",
  CODE_184: "שם מסוף",
  CODE_185: "העלאת קובץ",
  CODE_187: "הערה",
  CODE_188:
    "ניתן להעלות קבצי פוליגון בפורמט geojson בלבד, עד 9.5MB. הפוליגון חייב להיות מסוג Polygon או MultiPolygon בלבד, ובמערכת קואורדינטות EPSG:4326 (גלובלית) או EPSG:2039 (ישראל). העלאה מותרת רק במהלך יצירת מסוף ולא ניתן לערוך אותה מאוחר יותר.",
  CODE_189: "העלאת פוליגון",
  CODE_191: "שגיאה בקובץ",
  CODE_192: "יש לבחור קובץ אחד בלבד",
  CODE_193: "גודל הקובץ חייב להיות קטן מ-9.5MB",
  CODE_194: "הקובץ חייב להיות בפורמט geojson",
  CODE_195: "הפוליגון חייב להיות מסוג Polygon או MultiPolygon",
  CODE_196: "מערכת הקואורדינטות חייבת להיות EPSG:4326 או EPSG:2039",
  CODE_197: "יש לבחור ״סוג מסוף״",
  CODE_198: "יש לבחור ״בעלות״",
  CODE_199: "יש לבחור ״מיקום״",
  CODE_200: "יש לבחור ״שנת צורך תחבורתי״",
  CODE_201: "יש לבחור ״טבעת המסוף״",
  CODE_202: "יש לבחור ״ישימות״",
  CODE_203: "יש להעלות פוליגון",
  CODE_204: "מחיקת המסוף נכשלה",
  CODE_205: "האם את/ה בטוח/ה שברצונך למחוק את מסוף {terminalName} {terminalMakat}? המסוף ימחק על כל גרסאותיו אם קיימות.",
  CODE_206: "האם את/ה בטוח/ה שברצונך למחוק את גרסה {versionNumber} של מסוף {terminalName} {terminalMakat}?",
  CODE_207: "מחיקה",
  CODE_208: 'שים/י לב, כבר קיים מסוף בעל מק"ט מסוף {terminalMakat}. לא ניתן לייצר מסוף נוסף עם אותו מק"ט.',
  CODE_209: 'שים/י לב, כבר קיים מסוף בעל מק"ט ארז {terminalMakatErez}. לא ניתן לייצר מסוף נוסף עם אותו מק"ט ארז.',
  CODE_210: "מחיקת גרסת מודל נכשלה",
  CODE_211: "האם את/ה בטוח/ה שברצונך למחוק את גרסת מודל {modelNumber}?",
  CODE_212: "גרסת מודל {modelNumber} נמחקה בהצלחה",
  CODE_213: "משתמשים בעלי הרשאה למערכת",
  CODE_214: "ניהול משתמשים",
  CODE_215: "סינון לפי:",
  CODE_216: "מנהל",
  CODE_217: "מתכנן",
  CODE_218: "צופה",
  CODE_219: "ללא הרשאה",
  CODE_220: "טעינת המשתמשים נכשלה",
  CODE_221: "אין משתמשים להצגה",
  CODE_222: "אין משתמשים זמינים",
  CODE_223: "עדכון נתוני משתמש נכשל",
  CODE_224: "חיפוש משתמש",
  CODE_225: "הוספת ערכים",
  CODE_226: "עריכת שדות",
  CODE_227: "יצירת ערך חדש",
  CODE_228: "מחיקת ערך נכשלה",
  CODE_229: "עריכת ערך נכשלה",
  CODE_230: "הוספת ערך נכשלה",
  CODE_231: "טעינת הערכים נכשלה",
  CODE_232: "אין ערכים זמינים",
  CODE_233: "שימו לב, מחיקת הערך הזה תשפיע על {count} מסופים",
  CODE_234: "סינון הטבלה החזיר 0 שורות. לא ניתן לייצא לאקסל טבלה ריקה.",
  CODE_235: "יש לבחור ״סטטוס״",
  CODE_236: "השוואה",
  CODE_237: "רשות מקומית 2040",
  CODE_238: "מפה",
  CODE_239: "תצלום אוויר",
  CODE_240: "הקפאת גירסה",
  CODE_241: "האם את/ה בטוח/ה שברצונך להקפיא את גירסה {modelNumber}?",
  CODE_242: "הקפאה",
  CODE_243: "שים לב,",
  CODE_244: "הקפאה של גרסת ה-{modelNumber} תיצור גרסת מודל חדשה שלא יהיה ניתן לערוך אותה יותר.",
  CODE_245: "האם אתה בטוח שברצונך לבצע זאת?",
  CODE_246: "גרסת מודל {version} הוקפאה בהצלחה",
  CODE_247: "לא ניתן ליצור או להקפיא גירסת מודל בתוך 24 שעות מהגירסה האחרונה",
  CODE_248: "הקפאת הגירסה נכשלה",
  CODE_249: "גירסה",
  CODE_250: "מוקפאת",
  CODE_251: "אין אפשרות להוסיף מסוף חדש לגירסא מוקפאת",
  CODE_252: "שימי לב",
  CODE_253: "חזרה",
  CODE_254: "בקשות ממתינות לאישור",
  CODE_255: "להלן הבקשות לעדכון מסופים אשר ממתינות לאישור/דחייה של מנהל",
  CODE_256: "מבקש העדכון",
  CODE_257: "מק\"ט ארז",
  CODE_258: "שם מסוף",
  CODE_259: "טעינת הבקשות הממתינות נכשלה",
  CODE_260: "קיימת בקשה פתוחה למסוף זה. לא ניתן לשלוח בקשה נוספת עד לאישור או דחייה.",
  CODE_261: "יצירת בקשת השינוי נכשלה",
  CODE_262:
    'בקשתך לשינוי הערכים "שנת צורך תחבורתי" ו-"עמדת הרשות המקומית ומורכבות התיאומים" תועבר לאישור מנהל מערכת. יש לפרט את מהות השינוי בחלון כאן:',
  CODE_263: "פירוט מהות השינוי...",
  CODE_264:
    'בקשתך לעדכון הערכים "שנת צורך תחבורתי" ו-"עמדת הרשות המקומית ומורכבות התיאומים" במסוף {terminalName} מק"ט ארז {erezSKU} נשלחה בהצלחה לאישור מנהל',
  CODE_265: "יש לפרט את מהות השינוי",
  CODE_266: "שמור",
  CODE_267: "בקשת שינוי ממתינה לאישור",
  CODE_268: "היה:  ",
  CODE_269: "מבוקש:  ",
  CODE_270: "מבקש: ",
  CODE_271: "נימוק המתכנן",
  CODE_272: "היה ",
  CODE_273: "בקשה",
  CODE_274: "משפיע על ניקוד דחיפות",
  CODE_275: "ניקוד ישימות",
  CODE_276: "נימוק הבקשה",
  CODE_277: "דחייה",
  CODE_278: "אישור",
  CODE_279:
    'בקשה לשינוי הציון של מסוף {terminalName} מק"ט ארז {erezSKU} אושרה בהצלחה\nציון ודירוג המסוף עודכנו במערכת',
  CODE_280: "אישור בקשת השינוי נכשל",
  CODE_281: 'בקשה לשינוי הציון של מסוף {terminalName} מק"ט ארז {erezSKU} נדחתה בהצלחה',
  CODE_282: "דחיית בקשת השינוי נכשלה",
  CODE_283: "מסוף {terminalName} מכיל בקשה פתוחה",
  CODE_284: "סגור",
};

export default ConstantsTexts;
